import { z } from 'zod'

export const PaginationInputSchema = z
  .object({
    page: z.number().optional(),
    perPage: z.number().optional(),
  })
  .optional()

export type PaginationInput = z.infer<typeof PaginationInputSchema>

export const GetPaginationSchema = <T extends z.ZodType>(dataSchema: T) =>
  z.object({
    data: z.array(dataSchema),
    meta: z.object({
      current_page: z.number(),
      from: z.number().nullish(),
      last_page: z.number(),
      per_page: z.number(),
      to: z.number().nullish(),
      total: z.number().nullish(),
    }),
  })
